import React, { useState, useEffect } from 'react';
import { setCookieConsent, hasCookieConsent } from '../utils/cookieUtils';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (!hasCookieConsent()) {
      setShow(true);
    }
  }, []);

  const handleAccept = (): void => {
    setCookieConsent(true);
    setShow(false);
    // Trigger a custom event to notify theme context
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { detail: { consent: true } }));
  };

  const handleDecline = (): void => {
    setCookieConsent(false);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3>Cookie Preferences</h3>
          <p>
            We use cookies to remember your theme preference and improve your experience. 
            By clicking "Accept", you consent to our use of cookies.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button onClick={handleDecline} className="btn btn-outline btn-small">
            Decline
          </button>
          <button onClick={handleAccept} className="btn btn-primary btn-small">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
